"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCategories = void 0;
exports.TagCategories = {
    VULNERABILITY: 'vulnerability',
    PROGRAMMING_LANGUAGES: 'programming_languages',
    MONTH: 'month',
    YEAR: 'year',
    VIDEO_TUTORIALS: 'video_tutorials',
};
